export const size = {
  phone: 640,
  tablet: 1024,
  tabletLand: 1200,
}

export const device = {
  phone: `(max-width: ${size.phone - 1}px)`,
  tablet: `(min-width: ${size.phone}px) and (max-width: ${size.tablet - 1}px)`,
  tabletLand: `(min-width: ${size.tablet}px) and (max-width: ${
    size.tabletLand - 1
  }px)`,
  desktop: `(min-width: ${size.tabletLand}px)`,
}

export const spacing = (...sizes) => {
  const unit = 8
  if (!sizes.length) return '0px'
  const pixels = sizes.map(s => `${s * unit}px`)
  return pixels.join(' ')
}
